import script from "./StartSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./StartSignup.vue?vue&type=script&setup=true&lang=js"

import "./StartSignup.vue?vue&type=style&index=0&id=34e52124&lang=scss"

const __exports__ = script;

export default __exports__